import { useNavigate } from "react-router-dom";
import TCLayout from "../layouts/tc-layout/tc-layout";

const NoRouteMatch = ({ navigateTo = "/classify" }) => {
  const navigate = useNavigate();
  return (
    <TCLayout>
      <div className="tw-flex tw-items-center tw-justify-center tw-h-full">
        <div className="tw-text-center">
          <img width={650} height={650} src="https://res.cloudinary.com/drzta9shk/image/upload/q_auto/v1594848489/website/icons/No_data-cuate_1_qkn0d9.svg" alt="Trademo" />
          <div className="tw-text-[40px] tw-leading-none">404</div>
          <div className="tw-my-2 tw-text-heading-sm">Oops! Page not found!</div>
          <div className="tw-cursor-pointer tw-underline tw-font-medium tw-text-primary-purple-600 tw-underline-offset-1" onClick={() => navigate(navigateTo)}>
            Go Back
          </div>
        </div>
      </div>
    </TCLayout>
  );
};

export default NoRouteMatch;
